module.exports = __webpack_public_path__ + "assets/purple_background_mobile.ae4af779e0592b0e088aca16de616bde08e0968af331120a5b110be79888c981.jpg";